import { FacilityAdditionalContactBulkCreateForm } from 'application/facility/forms';
import { BaseEditViewStore } from 'core/stores';
import { FacilityAdditionalContactService } from 'application/facility/services';
import { action } from 'mobx';
import _ from 'lodash';

class FacilityAdditionalContactBulkCreateViewStore extends BaseEditViewStore {
    constructor(rootStore, componentParams) {
        const facilityId = rootStore.routerStore.routerState.params.id;
        const service = new FacilityAdditionalContactService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'facility-additional-contact-bulk',
            Form: FacilityAdditionalContactBulkCreateForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const response = await service.bulkCreate(_.extend(resource, {facilityId: facilityId}));
                        return response.data;
                    }
                }
            },
            
            FormClass: FacilityAdditionalContactBulkCreateForm,
        });

        this.componentParams = componentParams;
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);
            this.componentParams.modalParams.data.onSuccess();
            this.componentParams.modalParams.close();
            await setTimeout(() => this.rootStore.notificationStore.success("Contact(s) successfully added."));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }
}

export default FacilityAdditionalContactBulkCreateViewStore;